<template>
  <div v-if="loading" class="prpf-results__list prpf-results__list--loading">
    <div
      v-for="(width, index) in skeletonWidths"
      :key="index"
      class="prpf-results__skeleton-bar"
      :class="{ 'prpf-results__skeleton-bar--short': index % 2 === 1 }"
      :style="{ width: width + 'px' }"
    />
  </div>

  <div v-else class="prpf-results__list prpf-results__list--scroll">
    <div
      v-for="(option, index) in results"
      :key="option.id"
      class="prpf-results__row"
      :class="{ 'prpf-results__row--first': index === 0 }"
      role="option"
      @click.stop="$emit('select', option)"
    >
      <div class="prpf-results__row-head">
        <span class="prpf-results__row-name">{{ option.name }}</span>
        <span class="prpf-results__row-code">{{ option.code }}</span>
      </div>
      <p v-if="option.meta" class="prpf-results__row-meta">{{ option.meta }}</p>
    </div>
  </div>
</template>

<script setup>
defineProps({
  results: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
});

defineEmits(["select"]);

const skeletonWidths = [220, 160, 220, 160, 220, 160];
</script>

<style scoped>
.prpf-results__list--loading {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  box-sizing: border-box;
}

.prpf-results__list--scroll {
  display: flex;
  flex-direction: column;
  padding: 4px 0;
  max-height: 252px;
  overflow-y: auto;
  box-sizing: border-box;
}

.prpf-results__row {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  padding: 8px 12px;
  background: #fff;
  border-radius: 6px;
  cursor: pointer;
  box-sizing: border-box;
}

.prpf-results__row--first {
  background: #f9f5ff;
}

.prpf-results__row-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
}

.prpf-results__row-name {
  flex: 1;
  min-width: 0;
  color: #101828;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.prpf-results__row--first .prpf-results__row-name {
  color: #7f56d9;
}

.prpf-results__row-code {
  flex-shrink: 0;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #667085;
  line-height: 20px;
  white-space: nowrap;
}

.prpf-results__row-meta {
  margin: 0;
  color: #667085;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  white-space: pre-wrap;
}

.prpf-results__skeleton-bar {
  height: 12px;
  border-radius: 4px;
  background: #eaecf0;
  flex-shrink: 0;
}

.prpf-results__skeleton-bar--short {
  height: 10px;
}
</style>
